import { Controller, useFormContext } from "react-hook-form";
import { RadioGroup, RadioGroupProps } from "./radio-group";

export function ControlledRadioGroup<T = string | number>(
  props: Omit<RadioGroupProps<T>, "onValueChange" | "errorMessage"> & {
    name: string;
  },
) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => (
        <RadioGroup
          {...field}
          {...fieldState}
          onValueChange={(value) => {
            field.onChange(value);
          }}
          {...props}
          errorMessage={fieldState?.error?.message}
          isInvalid={!!fieldState?.error?.message}
        />
      )}
    />
  );
}
